import React from 'react';

function Dashboard() {
    return (
        <h1>HOme Page</h1>
    );
}

export default Dashboard;
